import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const AnswerList = () => {

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const questionId = searchParams.get("question_id");

  const [answers, setAnswers] = useState([]);
  const [question, setQuestion] = useState("");


  const [editData, setEditData] = useState({
  id: "",
  answer: "",
  correct_answer: ""
});

  useEffect(() => {
    fetchAnswers();
  }, []);

  const fetchAnswers = async () => {
    try {

      const res = await axios.get(
        `${API_BASE_URL}/answer_list/${questionId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );

      setAnswers(res.data.data.data);
      setQuestion(res.data.question);

    } catch (error) {
      toast.error("Failed to load answers");
    }
  };



  const handleEditSubmit = async (e) => {
  e.preventDefault();

  try {

    const res = await axios.post(
      API_BASE_URL + "/update_answer",
      {
        id: editData.id,
        answer: editData.answer,
        correct_answer: editData.correct_answer
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    toast.success(res.data.message);

    fetchAnswers();

    window.$('#editModal').modal('hide');

  } catch (error) {
    toast.error("Update failed");
  }
};



  const handleDelete = async (id) => {
    //alert(id);
  if (!window.confirm("Are you sure?")) return;

  try {
    const res = await axios.post(
      API_BASE_URL + "/delete_answer",
      { id },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    toast.success(res.data.message);
    fetchAnswers();

  } catch (error) {
    toast.error("Delete failed");
  }
};

  return (
    <>
      <ToastContainer />

      <div className="container-fluid">

        <div className="card mb-4">
          <div className="card-header">
            <span style={{ color: "blue", fontWeight: "600" }}>
              {question?.toUpperCase()}
            </span>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h6 className="card-title" style={{ color: "#e96827" }}>
              List All Answers
            </h6>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Answer</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {answers.length > 0 ? (
                    answers.map((ans, index) => (
                      <tr key={index}>
                        <td>
                          <i
  className="fe fe-edit mr-2 text-info"
  data-toggle="modal"
  data-target="#editModal"
  style={{ cursor: "pointer" }}
 onClick={() =>
  setEditData({
    ...ans,
    correct_answer:
      ans.correct_answer === 1 ||
      ans.correct_answer === "1" ||
      ans.correct_answer === "Right Answer"
        ? "1"
        : "2"
  })
}

/>
                          <i
  className="fe fe-trash text-danger"
  style={{ cursor: "pointer" }}
  onClick={() => handleDelete(ans.id)}
/>
                        </td>
                        <td>{ans.answer}</td>
                        <td>
                          {ans.correct_answer == 1
                            ? <span className="badge badge-success">Correct</span>
                            : <span className="badge badge-danger">Wrong</span>
                          }
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        No Answers Found
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>
          </div>

        </div>

{/* Edit Model */}


<div className="modal fade" id="editModal" tabIndex="-1">
  <form onSubmit={handleEditSubmit}>
    <div className="modal-dialog">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Edit Answer</h5>
          <button type="button" className="close" data-dismiss="modal">
            ×
          </button>
        </div>

        <div className="modal-body">

          <div className="form-group">
            <label>Answer</label>
            <input
              type="text"
              className="form-control"
              value={editData.answer || ""}
              onChange={(e) =>
                setEditData({ ...editData, answer: e.target.value })
              }
              required
            />
          </div>

          <div className="form-group">
            <label>Status</label>
            <select
              className="form-control"
             value={editData.correct_answer?.toString() || ""}
              onChange={(e) =>
                setEditData({ ...editData, correct_answer: e.target.value })
              }
              required
            >
              <option value="">Select</option>
              <option value="1">Correct</option>
              <option value="2">Wrong</option>
            </select>
          </div>

        </div>

        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-dismiss="modal">
            Close
          </button>
          <button className="btn btn-primary">
            Save Changes
          </button>
        </div>

      </div>
    </div>
  </form>
</div>

      </div>
    </>
  );
};

export default AnswerList;